import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import reportActions from '../../report/reportActions';

import MissingBeneficiaryFormsList from './MissingBeneficiaryFormsList';
import { Page, PageContent, PageHeader } from '../../components/common';
import Utils, { SecurityRoles } from '../../common/utils';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';

interface Props {
	actions: any;
	history: any;
	customers: UserDetails[];
}
interface State {
	customers: UserDetails[];
	isLoading: boolean;
	searchterm: string;
}
class MissingBeneficiaryFormsListPage extends React.Component<Props, State> {
	handleSearchDebounced = Utils.debounce(() => { this.search(this.state.searchterm); }, 200);

	constructor(props: Props) {
		super(props);
		this.state = {
			customers: [],
			isLoading: true,
			searchterm: ''
		};
	}

	componentDidMount() {
		this.props.actions
			.fetchCustomersMissingBeneficiaryForms()
			.then(() => this.setState({ customers: this.props.customers, isLoading: false }));
	}

	onSearch = (e: any) => {
		this.setState({ searchterm: e.target.value }, () => {
			this.handleSearchDebounced();
		});
	}
	search = (searchterm: string) => {
		const value = searchterm.toLowerCase();
		let customers = this.props.customers.filter(function (c: UserDetails) {
			let fullName = c.fullName || '';
			let email = c.email || '';
			return fullName.toLowerCase().startsWith(value) || email.toLowerCase().startsWith(value);
		});

		this.setState({ customers });
	}

	download = () => {
		const formattedCustomers = this.formatData(this.props.customers);
		Utils.downloadCsv(formattedCustomers, 'MissingBeneficiaryForms.csv');
	}
	formatData = (customers: UserDetails[]) => {
		const formattedCustomers = customers.map(c => {
			return {
				Name: c.fullName,
				Email: c.email
			};
		});

		return formattedCustomers;
	}

	render() {
		return (
			<Page title="Customers missing beneficiary forms">
				<PageContent>
					<PageHeader title="Customers Missing beneficiary forms" />
					<MissingBeneficiaryFormsList
						customers={this.state.customers}
						history={this.props.history}
						searchterm={this.state.searchterm}
						onSearch={this.onSearch}
						download={this.download}
					/>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		customers: state.user.customers
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...reportActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(MissingBeneficiaryFormsListPage);
const roles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, roles);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/MissingBeneficiaryFormsListPage.tsx